import { NoTradesSession } from "../types/NoTradesSession";
import { Session } from "../types/Session";

/** Sessions avec au moins un trade exécuté. */
export const getTradeSessions = (
    sessions: (Session | NoTradesSession)[]
): Session[] =>
    sessions.filter(
        (session): session is Session =>
            "Trade" in session && session.Trade.length > 0
    );

/**
 * Règle UI calendrier : une journée n'est verte que si toutes les sessions
 * avec trades respectent la méthode. Le % « méthode respectée » côté API
 * est calculé au niveau session (voir allsessionService).
 */
export const isDayMethodRespected = (
    sessions: (Session | NoTradesSession)[]
): boolean => {
    const tradeSessions = getTradeSessions(sessions);
    return (
        tradeSessions.length > 0 &&
        tradeSessions.every((session) => session.isMethodValid === true)
    );
};
